import {
  LOGIN,
  LOGOUT,
  SET_PREVIOUS_LOCATION,
  UNSET_PREVIOUS_LOCATION,
} from "store/auth/types";

import {setFetchMessage, setLoadingStatus} from "store/helper/actions";

import * as api from "lib/api";

import API_RESOURCES from "lib/api/resources";

import {SUCCESS_STATUS, ALERT_SEVERITY_ERROR, ERROR_STATUS} from "components/MessageService/constants";

/**
 * Action to validate email received from OAuth SignIn process
 *
 * @param userPayload
 * @returns {function(*): Promise<void>}
 */
export const login = (userPayload) => {
  return async (dispatch) => {
    dispatch(setLoadingStatus());

    try {
      const response = await api.post(API_RESOURCES.LOGIN, {
        email: userPayload.email,
        accessToken: userPayload.token
      }, false);

      // Check for error status
      if (response && response.code && (response.code === 401 || response.code === 403 || response.code === 400)) {
        dispatch(setFetchMessage({
          message: (response && response.message) || 'Login failed',
          type: ERROR_STATUS,
          severity: ALERT_SEVERITY_ERROR,
        }));
        return;
      }

      // Check for unauthorized message
      const msg = String(response?.message || '').toLowerCase();
      if (/unauthorized|disabled|no active roles|no active clients|user not found|user is not active/.test(msg)) {
        dispatch(setFetchMessage({
          message: (response && response.message) || 'Login failed',
          type: ERROR_STATUS,
          severity: ALERT_SEVERITY_ERROR,
        }));
        return;
      }

      dispatch(setFetchMessage(response))
      dispatch(setUserPayload(response.data));
    } catch (e) {
      dispatch(setFetchMessage(e));
    }
  }
}

/**
 * Sets user object in store
 *
 * @param userPayload
 * @returns {{payload: {userPayload: {role: string, name: string, email: string, token: string}}, type: string}}
 */
export const setUserPayload = (userPayload) => ({
  type: LOGIN,
  payload: {
    userPayload
  },
});

export const logout = () => {
  return (dispatch) => {
    try {
      const persisted = localStorage.getItem('persist:root');
      if (persisted) {
        const parsed = JSON.parse(persisted);
        parsed.authReducer = JSON.stringify({ isAuthenticated: false, authObject: null, previousLocation: null });
        localStorage.setItem('persist:root', JSON.stringify(parsed));
      }
    } catch (e) {}
    dispatch({ type: LOGOUT });
  };
};

export const refreshAuth = () => {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const authObject = state?.authReducer?.authObject;
      if (!authObject || !authObject._id) return;

      // Send currentUser exlicitly and skip withUser so token pre-check doesn't block
      const response = await api.post(
        API_RESOURCES.AUTH_REFRESH,
        { currentUser: authObject },
        false
      );
      if (response && response.data) {
        dispatch(setUserPayload(response.data));
      }
    } catch (e) {
    }
  };
}

export const setPreviousLocation = (previousLocation) => ({
  type: SET_PREVIOUS_LOCATION,
  payload: {
    previousLocation,
  },
});

export const unsetPreviousLocation = () => ({
  type: UNSET_PREVIOUS_LOCATION,
});
